module.exports = __webpack_public_path__ + "img/example4.f88766aa.jpg";